import React from "react";
import LoginForm from "../components/auth/LoginForm";
import AuthPageShell from "../components/auth/AuthPageShell";
import useAuthPageRedirect from "../hooks/useAuthPageRedirect";

const LoginPage = () => {
  const { onSuccess, goToSignup } = useAuthPageRedirect();

  return (
    <AuthPageShell>
      <LoginForm onClose={onSuccess} switchToSignup={goToSignup} />
    </AuthPageShell>
  );
};

export default LoginPage;
